import { formatPrice } from '@shared/utils/price-formatter';

export const SERVICE_LINE_COLUMNS = [
  { header: 'Nummer', field: 'recordNumber', sortable: true, width: '80px' },
  {
    header: 'Beschreibung',
    field: 'description',
    sortable: true,
    formatter: (row: any) => {
      return row.name || row.description || '';
    },
  },
  {
    header: 'Menge',
    field: 'quantity',
    sortable: true,
    formatter: (value: any) => value.quantity,
  },
  {
    header: 'Einheit',
    field: 'unit.name',
    sortable: true,
    formatter: (value: any) => value.unit?.name || '',
  },
  {
    header: 'Einzelpreis',
    field: 'unitPrice',
    sortable: true,
    formatter: (value: any) => {
      const unitPrice = parseFloat(String(value?.unitPrice)) || 0;
      return formatPrice(unitPrice) + ' €';
    },
  },
  {
    header: 'Gesamtpreis',
    field: 'totalPrice',
    sortable: false,
    formatter: (row: any) => {
      const quantity = parseFloat(row.quantity) || 0;
      const price = parseFloat(row.unitPrice) || 0;
      return formatPrice(quantity * price) + ' €';
    },
  },
  {
    header: 'Kommentar',
    field: 'serviceProviderComment',
    sortable: false,
  },
];
